import React, {useRef, useState} from 'react';
import cl from "../BaseSimplePage/BaseSimplePage.module.css";
import SubscriptionCancellationsBrowseBrowser from "./SubscriptionCancellationsBrowseBrowser";
import SubscriptionCancellationsBrowseEditor from "./SubscriptionCancellationsBrowseEditor";

const ITEMS_PER_RQ_PAGE = 30;

const SubscriptionCancellationsBrowseSubPage = ({isAddSubMode}) => {

    const [filteredItems, setFilteredItems] = useState([]);
    const rqIdCounter = useRef(0);
    const [status, setStatus] = useState(""); // "", idle, mainLoad, addLoad, mainError, typing
    const [pagination, setPagination] = useState({is_last: true})

    const [dateFromText, setDateFromText] = useState('');
    const [dateTillText, setDateTillText] = useState('');

    return (
        <div className={cl.main0}>
            <div className={cl.mainRow}>
                {!isAddSubMode && <div className={cl.browserArea} style={undefined}>
                    <SubscriptionCancellationsBrowseBrowser
                        setFilteredItems={setFilteredItems}
                        rqIdCounter={rqIdCounter}
                        status={status}
                        setStatus={setStatus}
                        pagination={pagination}
                        setPagination={setPagination}
                        ITEMS_PER_RQ_PAGE={ITEMS_PER_RQ_PAGE}
                        dateFromText={dateFromText}
                        setDateFromText={setDateFromText}
                        dateTillText={dateTillText}
                        setDateTillText={setDateTillText}
                    />
                </div>}
                <div className={cl.editorArea}>
                    <SubscriptionCancellationsBrowseEditor
                        filteredItems={filteredItems}
                        setFilteredItems={setFilteredItems}
                        rqIdCounter={rqIdCounter}
                        status={status}
                        setStatus={setStatus}
                        pagination={pagination}
                        setPagination={setPagination}
                        ITEMS_PER_RQ_PAGE={ITEMS_PER_RQ_PAGE}
                        dateFromText={dateFromText}
                        dateTillText={dateTillText}
                    />
                </div>
            </div>
        </div>
    );
};

export default SubscriptionCancellationsBrowseSubPage;